export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9077.47e4305c.jpg";